import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { getIntlLocale } from '@/shared/i18n';

import { relativeTimeLabel } from './format';

export interface IdleChipProps {
  /** `currentEpisode.lastActivityAt` — the tooltip's "no activity since {{value}}". */
  lastActivityAt: string;
}

/**
 * "Idle" badge next to the status chip when `currentEpisode.idle` is true (design §11.1). Neutral
 * colour on purpose: idle is information, not a fault.
 */
export function IdleChip({ lastActivityAt }: IdleChipProps) {
  const { t } = useTranslation('conversations');
  const locale = getIntlLocale();
  const tooltip = t('status.idleTooltip', { value: relativeTimeLabel(lastActivityAt, locale) });
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<HourglassEmptyRoundedIcon fontSize="inherit" />}
      label={t('status.idle')}
      title={tooltip}
      aria-description={tooltip}
    />
  );
}
